(() => {
  'use strict';

  if (window.__rdHomeHeroRegistered) return;

  const register = () => {
    if (!window.RD?.register || window.__rdHomeHeroRegistered) return;

    window.__rdHomeHeroRegistered = true;

    window.RD.register('hero', (root) => {
      const viewport = root.querySelector('[data-rd-hero-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-rd-hero-slide]'));

      if (!viewport || slides.length <= 1) return;

      const autoplay = root.dataset.autoplay === 'true';
      const autoplaySpeed = Math.max(
        2500,
        Number(root.dataset.autoplaySpeed) || 5000
      );
      const pauseOnHover = root.dataset.pauseHover === 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let active = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      let timer = 0;
      let dragging = false;
      let startX = 0;
      let deltaX = 0;

      const setSlide = (index) => {
        active = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === active;

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        root.querySelectorAll('[data-rd-hero-dot]').forEach((dot, dotIndex) => {
          const isActive = dotIndex === active;

          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = 0;
      };

      const play = () => {
        stop();

        if (!autoplay || reduceMotion || document.hidden) return;

        timer = window.setInterval(
          () => setSlide(active + 1),
          autoplaySpeed
        );
      };

      const onClick = (event) => {
        const prev = event.target.closest('[data-rd-hero-prev]');
        const next = event.target.closest('[data-rd-hero-next]');
        const dot = event.target.closest('[data-rd-hero-dot]');

        if (prev && root.contains(prev)) {
          setSlide(active - 1);
          play();
          return;
        }

        if (next && root.contains(next)) {
          setSlide(active + 1);
          play();
          return;
        }

        if (dot && root.contains(dot)) {
          setSlide(Number(dot.dataset.rdHeroDot) || 0);
          play();
        }
      };

      const onPointerDown = (event) => {
        if (event.target.closest('a, button')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        dragging = true;
        startX = event.clientX;
        deltaX = 0;

        stop();
        viewport.setPointerCapture?.(event.pointerId);
      };

      const onPointerMove = (event) => {
        if (!dragging) return;

        deltaX = event.clientX - startX;
      };

      const finishSwipe = () => {
        if (!dragging) return;

        dragging = false;

        if (Math.abs(deltaX) > 48) {
          setSlide(active + (deltaX < 0 ? 1 : -1));
        }

        deltaX = 0;
        play();
      };

      const onVisibilityChange = () => {
        if (document.hidden) {
          stop();
        } else {
          play();
        }
      };

      const onPointerEnter = () => {
        if (pauseOnHover) stop();
      };

      const onPointerLeave = () => {
        if (pauseOnHover) play();
      };

      const onBlockSelect = (event) => {
        const selected = event.target?.closest?.('[data-rd-hero-slide]');

        if (!selected || !root.contains(selected)) return;

        stop();
        setSlide(Number(selected.dataset.index) || 0);
      };

      const onBlockDeselect = (event) => {
        if (root.contains(event.target)) play();
      };

      root.addEventListener('click', onClick);

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove, { passive: true });
      viewport.addEventListener('pointerup', finishSwipe);
      viewport.addEventListener('pointercancel', finishSwipe);
      viewport.addEventListener('pointerenter', onPointerEnter);
      viewport.addEventListener('pointerleave', onPointerLeave);

      document.addEventListener('visibilitychange', onVisibilityChange);
      document.addEventListener('shopify:block:select', onBlockSelect);
      document.addEventListener('shopify:block:deselect', onBlockDeselect);

      play();

      return () => {
        stop();

        root.removeEventListener('click', onClick);

        viewport.removeEventListener('pointerdown', onPointerDown);
        viewport.removeEventListener('pointermove', onPointerMove);
        viewport.removeEventListener('pointerup', finishSwipe);
        viewport.removeEventListener('pointercancel', finishSwipe);
        viewport.removeEventListener('pointerenter', onPointerEnter);
        viewport.removeEventListener('pointerleave', onPointerLeave);

        document.removeEventListener('visibilitychange', onVisibilityChange);
        document.removeEventListener('shopify:block:select', onBlockSelect);
        document.removeEventListener('shopify:block:deselect', onBlockDeselect);
      };
    });
  };

  if (window.RD?.register) {
    register();
  } else {
    document.addEventListener('DOMContentLoaded', register, { once: true });
  }
})();
